import React from "react";

export const isNull = (value) => {
  if(value === null || value === undefined || value === '') {
    return true;
  } else {
    return false;
  }
};

export const formatWriterName = (name) => {
  return name.length <= 2 ?
    name.slice(0, 1) + '*'.repeat(name.length - 1) :
    name.slice(0, 1) + '*'.repeat(name.length - 2) + name.slice(-1);
};

export const convertNewlineToBr = (text) => {
  const lines = text.split('\n');
  const filteredLines = lines.filter(line => line.trim() !== '');
  return filteredLines.join('<br/>');
};

